class AjaxForm {
    constructor(form, event) {
        this.form = form;
        this.event = event;
    }
    submitForm() {
        this.event.preventDefault();
        const url = this.form.attr('action');
        const method = this.form.attr('method');
        const data = this.form.serialize();
        $('.ajax-html-container').removeClass('show-html-container');

        $.ajax({
            method: method
            , url: url
            , data: data
            , dataType: 'JSON'
        }).done((data) => {
            try {
                if (data.status) {

                    if (data.redirect.length) window.location.replace(data.redirect);

                } else {
                    new AjaxFormActions(this.form, null, null, data.html_append).appendHtml();
                    new AjaxFormActions(this.form, data.errors, null, null).addErrors();
                    new AjaxFormActions(this.form, null, null, null).removeErrorsOnFocus();
                }
            } catch (e) {
                console.log(e);
            }
        }).always(function (data) {
            console.log(data);
        });
    }
}

class AjaxFormActions {
    constructor(form, errors, success, ajaxHtmlArray) {
        this.form = form;
        this.errors = errors;
        this.success = success;
        this.ajaxHtmlArray = ajaxHtmlArray;
    }
    clearFields() {
        this.form.find('input:not([type="hidden"]):not([type="checkbox"]), textarea').val('').blur();
        this.form.find('input[type="checkbox"]').prop('checked', false);
    }
    appendHtml() {
        let target = $(this.ajaxHtmlArray[0].target);
        let html = $(this.ajaxHtmlArray[0].data);
        target.addClass('show-html-container').html(html);

        // console.log(target, 'target');
        // console.log(target, 'data');
    }
    addErrors() {
        $.each(this.errors, (key, field) => {
            this.form.find("[name='" + key + "']").addClass('is-invalid');
            this.form.find("[name='" + key + "']").parent().find('.invalid-feedback').html(field);
        })
    }
    showSuccess() {
        this.form.find('.success-msg').html(this.success).addClass('show-success');
        setTimeout(() => { this.form.find('.success-msg').removeClass('show-success') }, 1000);
    }
    removeErrorsOnFocus() {
        try {
            this.form.on('focus', 'input, textarea', e => $(e.currentTarget).removeClass('is-invalid'));
        } catch (e) {
            console.log(e);
        }
    }
}

export default AjaxForm;